
import React, { useEffect, useState } from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';
import { doorSensorDetails } from '../common/ApiCall';

function DoorSensor({data}) {
  let [deviceDetail,setDeviceDetails] = useState({})
  useEffect(()=>{
    doorSensorDetails(data?.deviceId).then(res=>{
      if(Object.keys(res).length===0){
        setDeviceDetails(data)
      }else{
      setDeviceDetails(res)
      }
    })
  },[data])
  return (
    <DetailContainer
      name={"Door Status"}
      value={deviceDetail?.doorState===1?"Open":"Close"}
      time={deviceDetail?.doorState===1?(deviceDetail?.openSince ?? new Date()):(deviceDetail?.closeSince ?? new Date())}
      color={"rgba(50, 47, 200, 0.10)"}
      borderColor={"#322FC8"}
      image={deviceDetail?.doorState===1?images.doorOpen:images.doorClose}
    />
  )
}

export default DoorSensor